import React from 'react';
import styles from './DetailsSkeleton.module.scss';
import { Skeleton } from 'esa-ui-library';

const DetailsSkeleton = (): JSX.Element => (
	<section className={`${styles.DetailsSkeleton}`}>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={32} />
		</div>
	</section>
);

export { DetailsSkeleton };
